import React, { useEffect, useState } from 'react'
import Loading from '../../../../Component/Loading'
import { RoleTitle } from '../../../../Context/constants'
import { useNavigate, useParams } from 'react-router-dom'
import useReduxData from '../../../../Hooks/useReduxData'
import { FaArrowLeft } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { GET_VENDOR_DETAILS } from '../../../Repository/SettingRepo'
import { COUNTRY_LIST, STATE_LIST } from '../../../Repository/CommonRepo';
import { useFormik } from 'formik'
import { Errors } from '../../../../Component/Error'
import { EDIT_VENDOR_DETAILS } from '../../../Repository/SettingRepo'
import PhoneNumber from '../../../../Component/PhoneInput';
import { SearchAbleSelectBox } from '../../../../Component/Inputs'
import useMuiCompontent from '../../../../Hooks/useMuiCompontent'
import { UpdateVendorValidation } from '../../../../Context/Validation'

const EditVendorDetails = () => {
    const [loader, setLoader] = useState(false)
    const [vendorDetails, setVendorDetails] = useState({})
    const navigate = useNavigate()
    const { id } = useParams()
    const { reduxData: userdata } = useReduxData("userDataRDX")
    const [ListDataCountry, setListDataCountry] = useState([])
    const [ListState, setListState] = useState([])
    const { CustomButton } = useMuiCompontent()
    // const [listCategoryData, setListCategoryData] = useState([])

    // const [openModal, setOpenModal] = useState({
    //     add: false,
    //     archive: false,
    //     tests: false,
    //     view: false,
    //     addCategory: false,
    //     data: null,
    //     previoursData: null
    // })

    // const handleOpenModal = (type, data = null) => {
    //     setOpenModal((prev) => ({
    //         ...prev,
    //         data: data,
    //         previoursData: data,
    //         [type]: true,
    //     }));
    // };
    // const handleClosedModal = (type, isNull) => {
    //     setOpenModal((pre) => ({
    //         ...pre,
    //         data: null,
    //         previoursData: isNull ? null : pre?.previoursData,
    //         [type]: false
    //     }))
    // }

    const getVendorDetails = async () => {
        let payload = {
            id: id,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF)
                ? userdata?.providerId
                : userdata?.userId,
        }
        setLoader(true)
        try {
            let response = await GET_VENDOR_DETAILS(payload)
            setVendorDetails(response?.data)
        } catch (error) {
            toast.error(error.message)
            setVendorDetails({})
        } finally {
            setLoader(false)
        }
    }

    const getStateList = async (countryId, StateId) => {
        let payload = {
            countryId: countryId,
            activeStatus: true
        }
        setLoader(true)
        try {
            let response = await STATE_LIST(payload)
            setListState(response.data)
            if (countryId && StateId) {
                const StateDetails = response.data.filter((cur) => cur?.stateId === StateId)
                vendorFormik.setFieldValue("state", StateDetails)
            }
        } catch (error) {
            setListState([])
            toast.error(error.message)
            vendorFormik.setFieldValue("state", [])
        } finally {
            setLoader(false)
        }
    }


    // get list counry api
    async function listcountrys(countryId) {
        let payload = { activeStatus: true }
        setLoader(true)
        try {
            let response = await COUNTRY_LIST(payload)
            setListDataCountry(response.data)
            if (countryId) {
                const countryDetails = response.data.filter((cur) => cur?.id === countryId)
                vendorFormik.setFieldValue("country", countryDetails)
            }
        } catch (error) {
            setListDataCountry([])
        } finally {
            setLoader(false)
        }
    }

    // async function getProductCategoryList(categoryId) {
    //     setLoader(true)
    //     const payload = {
    //         activeStatus: true,
    //         providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
    //         frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    //     };
    //     try {
    //         let response = await LIST_CATEGORY(payload)
    //         setListCategoryData(response?.data);
    //         if (categoryId) {
    //             const categoryDetails = response.data.filter((cur) => cur?.id === categoryId)
    //             vendorFormik.setFieldValue("category", categoryDetails)
    //         }
    //         setLoader(false)
    //     } catch (error) {
    //         if (error.message !== "No details found") toast.error(error.message)
    //         setListCategoryData([])
    //         setLoader(false)
    //     }
    // }

    // const addProductCategory = useFormik({
    //     enableReinitialize: true,
    //     initialValues: {
    //         name: "",
    //     },
    //     onSubmit: async (values) => {
    //         console.log("Submitting payload", values);
    //         setLoader(true)
    //         let payload = {
    //             ...values,
    //             providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
    //             frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    //         }
    //         try {
    //             let response = await INSERT_CATEGORY(payload)
    //             toast.success(response.message)
    //             await getProductCategoryList()
    //             addProductCategory.resetForm()
    //             handleClosedModal("addCategory", true)
    //             setLoader(false)
    //         } catch (error) {
    //             toast.error(error.message)
    //             setLoader(false)
    //         }
    //     }
    // })


    const vendorFormik = useFormik({
        initialValues: {
            firstName: vendorDetails?.name || "",
            // lastName: vendorDetails?.lastName || "",
            mobile: vendorDetails?.mobile || "",
            email: vendorDetails?.email || "",
            gstNumber: vendorDetails?.gstNumber || "",
            panNumber: vendorDetails?.panNumber || "",
            bankName: vendorDetails?.bankName || "",
            accountNumber: vendorDetails?.accountNumber || "",
            ifscSwiftCode: vendorDetails?.ifscSwiftCode || "",
            paymentTerms: vendorDetails?.paymentTerms || "",
            creditLimit: vendorDetails?.creditLimit || "",
            taxRegistrationNumber: vendorDetails?.taxRegistrationNumber || "",
            leadTime: vendorDetails?.leadTime || "",
            address: vendorDetails?.address || "",
            city: vendorDetails?.city || "",
            state: [],
            country: [],
            category: vendorDetails?.category || "",
            notes: vendorDetails?.notes || "",
            vendorId: vendorDetails?.vendorId || "",
            zipCode: vendorDetails?.zipCode || "",
            rating: vendorDetails?.rating || "",
            // street: vendorDetails?.street || "",
        },
        validationSchema: UpdateVendorValidation,
        enableReinitialize: true,
        onSubmit: async (values) => {
            let payload = {
                ...values,
                id,
                providerId:
                    userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF
                        ? userdata?.providerId
                        : userdata?.userId,
                // category: values.category?.[0]?.id,
                state: values.state?.[0]?.stateId,
                country: values.country?.[0]?.id
            };

            setLoader(true);
            try {
                let response = await EDIT_VENDOR_DETAILS(payload);
                toast.success(response?.message);
                getVendorDetails()
                navigate("/setting/inventory", { state: { tab: 3 } })
                setLoader(false)
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoader(false);
            }
        },
    });
    const handalSearchAbleSelectBox = (event, newValue, name) => {
        if (name === "country") {
            vendorFormik.setFieldValue("country", newValue)
            vendorFormik.setFieldValue("state", [])
            if (newValue?.length > 0) {
                getStateList(newValue[0]?.id, null) // load states
            }
        }
        // else if (name === "category") {
        //     vendorFormik.setFieldValue("category", newValue)
        // }
        else {
            vendorFormik.setFieldValue(name, newValue)
        }
    }


    useEffect(() => {
        getVendorDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Fetch country list once
    useEffect(() => {
        listcountrys(null);
        // getProductCategoryList(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // After vendor details come in, just set selected
    useEffect(() => {
        if (vendorDetails?.countryId) {
            const countryDetails = ListDataCountry.filter(
                (cur) => cur?.id === vendorDetails?.countryId
            );
            vendorFormik.setFieldValue("country", countryDetails);

            if (vendorDetails?.stateId) {
                getStateList(vendorDetails?.countryId, vendorDetails?.stateId);
            }
        }
        // if (vendorDetails?.categoryId) {
        //     const categoryDetails = listCategoryData.filter(
        //         (cur) => cur?.id === vendorDetails?.categoryId
        //     );
        //     vendorFormik.setFieldValue("category", categoryDetails);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vendorDetails, ListDataCountry]);



    return (
        <>
            {loader && <Loading />}
            <div className="common-component-box">
                <header className="body_header">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                        <div className="d-flex align-items-center mb-2 mb-md-0">
                            <FaArrowLeft
                                className="me-2 cursor"
                                onClick={() => navigate("/setting/inventory", { state: { tab: 3 } })}
                                role="button"
                                aria-label="Go Back"
                                title="Go Back"
                                style={{ fontSize: "1.2rem" }}
                            />
                            <h2 className="page_name mb-0">Vendor Details</h2>
                        </div>
                    </div>
                </header>
                <div className="row common-white-bg-box mx-0 shadow d-flex align-content-start  position-relative px-2">
                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        {/* <div className="row">
            <div className="col-3">
              <label className="form-label mb-0">Patient ID</label>
            </div>
            <div className="col-4">
              <input type="text" value={addPatint?.values?.patientId||""} readOnly className="form-control" disabled={true} maxLength={50} name='patientId' />
            </div>
          </div> */}
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Vendor ID</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" value={vendorFormik?.values?.vendorId} readOnly className="form-control" disabled={true} maxLength={50} name='vendorId' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0"> Vendor/Company Name<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input maxLength={50} type="text" className="form-control" name='firstName' value={vendorFormik.values.firstName}
                                            onChange={(e) => vendorFormik.setFieldValue("firstName", e.target.value)} />
                                        <Errors formikfun={vendorFormik} name={"firstName"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Category<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7 d-flex">
                                        <div className="col-lg-11 w-100">
                                            {/* <SearchAbleSelectBox
                                                multiple={false}
                                                option={listCategoryData}
                                                getOptionLabel="name"
                                                isOptionEqualToValue="id"
                                                value={vendorFormik?.values?.category}
                                                name="category"
                                                handalSearchAbleSelectBox={handalSearchAbleSelectBox}
                                            /> */}
                                            <input maxLength={50} type="text" className="form-control" name='category' value={vendorFormik.values.category}
                                                onChange={(e) => vendorFormik.setFieldValue("category", e.target.value)} />
                                            <Errors formikfun={vendorFormik} name="category" />
                                        </div>
                                        <div className="col-lg-1 text-center px-4">

                                            {/* <Tooltip title=" Add Category" placement="right" style={{ cursor: "pointer" }}>
                                                <Fab color="primary" aria-label="add" size="small" className='mt-1' style={{ background: "#38C4B9", width: "27px", height: "27px", minHeight: "0" }}
                                                    onClick={() => {
                                                        handleOpenModal("addCategory", openModal?.previoursData);
                                                        handleClosedModal("add");
                                                    }}
                                                >
                                                    <AddIcon />
                                                </Fab>
                                            </Tooltip> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>


                    {/* <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0"> Last Name<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input maxLength={50} type="text" className="form-control" name='lastName' value={vendorFormik.values.lastName}
                                            onChange={(e) => vendorFormik.setFieldValue("lastName", e.target.value)} />
                                        <Errors formikfun={vendorFormik} name={"lastName"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div> */}

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Mobile Number<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7 mobile_number_input_box">
                                        <div className="input_group_mobile mb-0">
                                            <PhoneNumber
                                                width={false}
                                                Require={false}
                                                Name="mobile"
                                                HandleChange={vendorFormik}
                                                Value={vendorFormik.values.mobile}
                                            // disabledInput={true}
                                            />
                                        </div>
                                        <Errors formikfun={vendorFormik} name={"mobile"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Email Address<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="email" className="form-control" name='email' onChange={(e) => vendorFormik.setFieldValue("email", e.target.value)}
                                            value={vendorFormik.values.email} />
                                        <Errors formikfun={vendorFormik} name={"email"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">GST No.</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='gstNumber' onChange={(e) => vendorFormik.setFieldValue("gstNumber", e.target.value)}
                                            value={vendorFormik.values.gstNumber} />
                                        {/* <Errors formikfun={vendorFormik} name={"gstNumber"} /> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">PAN No.</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='panNumber' onChange={(e) => vendorFormik.setFieldValue("panNumber", e.target.value)}
                                            value={vendorFormik.values.panNumber} />
                                        {/* <Errors formikfun={vendorFormik} name={"panNumber"} /> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Bank Details</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" placeholder='Account No. / Bank Name' className="form-control" name='bankDetails' onChange={(e) => vendorFormik.setFieldValue("bankDetails", e.target.value)}
                                            value={vendorFormik.values.bankDetails || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div> */}

                    <div className="col-sm-12  pb-2 mt-4 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Bank Details</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" placeholder="Account Number" maxLength={50} className="form-control" name="accountNumber" value={vendorFormik.values.accountNumber}
                                            onChange={(e) => vendorFormik.setFieldValue("accountNumber", e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-2 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" placeholder="IFSC/SWIFT code" maxLength={50} className="form-control" name="ifscSwiftCode" value={vendorFormik.values.ifscSwiftCode}
                                            onChange={(e) => vendorFormik.setFieldValue(`ifscSwiftCode`, e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-2 " style={{ borderBottom: "2px solid #ededed" }}>
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" placeholder="Bank Name" maxLength={50} className="form-control" name="bankName" value={vendorFormik.values.bankName}
                                            onChange={(e) => vendorFormik.setFieldValue(`bankName`, e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Payment Terms</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='paymentTerms' onChange={(e) => vendorFormik.setFieldValue("paymentTerms", e.target.value)}
                                            value={vendorFormik.values.paymentTerms || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Credit Limit</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='creditLimit' onChange={(e) => vendorFormik.setFieldValue("creditLimit", e.target.value)}
                                            value={vendorFormik.values.creditLimit || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Tax Registration No.<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='taxRegistrationNumber' onChange={(e) => vendorFormik.setFieldValue("taxRegistrationNumber", e.target.value)}
                                            value={vendorFormik.values.taxRegistrationNumber || ""} />
                                        <Errors formikfun={vendorFormik} name={"taxRegistrationNumber"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Lead Time</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='leadTime' onChange={(e) => vendorFormik.setFieldValue("leadTime", e.target.value)}
                                            value={vendorFormik.values.leadTime || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Rating/Score<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='rating' onChange={(e) => vendorFormik.setFieldValue("rating", e.target.value)}
                                            value={vendorFormik.values.rating || ""} />
                                        <Errors formikfun={vendorFormik} name={"rating"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>


                    <div className="col-sm-12  py-3 " style={{ borderBottom: "2px solid #ededed" }}>

                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Remarks</label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" className="form-control" name='notes' onChange={(e) => vendorFormik.setFieldValue("notes", e.target.value)}
                                            value={vendorFormik.values.notes || ""} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12  pb-2 mt-4 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label className="form-label mb-0">Address Details<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" placeholder="Address" maxLength={50} className="form-control" name="address" value={vendorFormik.values.address}
                                            onChange={(e) => vendorFormik.setFieldValue(`address`, e.target.value)}
                                        />
                                        <Errors formikfun={vendorFormik} name={"address"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-sm-12  py-2 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <input type="text" maxLength={50} className="form-control" name="street" placeholder="Street " value={vendorFormik.values.street}
                                            onChange={(e) => vendorFormik.setFieldValue(`street`, e.target.value)}
                                        />
                                        <Errors formikfun={vendorFormik} name={"street"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div> */}
                    <div className="col-sm-12  py-2 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <SearchAbleSelectBox
                                            placeholder="Select Country"
                                            multiple={false}
                                            option={ListDataCountry}
                                            getOptionLabel="countryName"
                                            isOptionEqualToValue="id"
                                            value={vendorFormik?.values?.country}
                                            name="country"
                                            handalSearchAbleSelectBox={handalSearchAbleSelectBox}
                                        />
                                        <Errors formikfun={vendorFormik} name={"country"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-2 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <SearchAbleSelectBox
                                            placeholder="Select State"
                                            multiple={false}
                                            option={ListState}
                                            getOptionLabel="stateName"
                                            isOptionEqualToValue="stateId"
                                            value={vendorFormik?.values?.state}
                                            name="state"
                                            handalSearchAbleSelectBox={handalSearchAbleSelectBox}
                                        />
                                        <Errors formikfun={vendorFormik} name={"state"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-2 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            maxLength={50}
                                            className="form-control"
                                            name="city"
                                            placeholder="City"
                                            value={vendorFormik.values.city}
                                            onChange={(e) => vendorFormik.setFieldValue(`city`, e.target.value)}
                                        />
                                        <Errors formikfun={vendorFormik} name={"city"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12  py-2 " >
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="row">
                                    <div className="col-lg-5">
                                    </div>
                                    <div className="col-lg-7">
                                        <input
                                            type="text"
                                            maxLength={50}
                                            className="form-control"
                                            name="zipCode"
                                            placeholder="zipCode"
                                            value={vendorFormik.values.zipCode}
                                            onChange={(e) => vendorFormik.setFieldValue(`zipCode`, e.target.value)}
                                        />
                                        <Errors formikfun={vendorFormik} name={"zipCode"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 d-grid justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end justify-content-xl-end justify-content-xxl-end py-3">
                        <CustomButton variant="contained" onClick={vendorFormik.handleSubmit} >Update</CustomButton>
                    </div>
                </div>

            </div>

            {/* <Modal show={openModal.addCategory} onHide={() => handleClosedModal("addCategory")} centered>
                <Modal.Body>
                    <div className="text-center">
                        <h4 className="modal-title mb-3">Add Category</h4>
                    </div>
                    <div className="modal-body  cus-i">
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label mb-0">Category<span className='Star_Mark'>*</span></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                value={addProductCategory?.values?.name}
                                onChange={(e) => addProductCategory?.setFieldValue("name", e.target.value)}
                            />
                            <Errors formikfun={addProductCategory} name={"name"} />
                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <CustomButton variant="contained" onClick={addProductCategory.handleSubmit} >Save</CustomButton>
                    </div>
                </Modal.Body>
            </Modal> */}
        </>
    )
}

export default EditVendorDetails
